import { render, staticRenderFns } from "./PubsComp.vue?vue&type=template&id=de211692"
import script from "./PubsComp.vue?vue&type=script&lang=js"
export * from "./PubsComp.vue?vue&type=script&lang=js"
import style0 from "./PubsComp.vue?vue&type=style&index=0&id=de211692&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports